import { IconSparkles } from '@tabler/icons-react';

interface AnswerCapsuleProps {
  children: React.ReactNode;
  label?: string;
}

/**
 * Answer-first capsule: a 120–150 word direct answer placed immediately after
 * the H1. Written to be lifted verbatim by AI engines and featured snippets.
 */
export function AnswerCapsule({ children, label = 'Quick answer' }: AnswerCapsuleProps) {
  return (
    <div className="rounded-[22px] p-5 sm:p-6 mb-10" style={{ background: 'var(--warm-surface)', border: '1px solid var(--warm-border)' }}>
      <div className="flex items-center gap-2 mb-2.5">
        <span className="size-7 rounded-lg flex items-center justify-center" style={{ background: 'var(--warm-card)' }}>
          <IconSparkles size={15} stroke={1.5} style={{ color: 'var(--warm-text)' }} />
        </span>
        <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: 'var(--warm-muted)' }}>{label}</span>
      </div>
      <div className="text-[15px] leading-relaxed" style={{ color: 'var(--warm-text)' }}>{children}</div>
    </div>
  );
}
